<template>
    <NotificationsManager />
    <header class="content-grid">
        <div>
            <div class="main-logo">
                <NuxtLink to="/">
                    <img src="/logo.svg" width="64" height="64" alt="Foldwrap logo" />
                </NuxtLink>
            </div>

            <div class="menu">
                <ul>
                    <li>
                        <NuxtLink to="/ai">AI</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink class="extra-link" to="/figma_plugin">Figma plugin</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink to="/pricing">Pricing</NuxtLink>
                    </li>
                    <li>
                        <NuxtLink class="extra-link" to="/blog">Blog</NuxtLink>
                    </li>
                    <li>
                        <span v-if="auth_store.is_authenticated">
                            <NuxtLink to="/user/account">Account</NuxtLink>
                            <UIAvatar
                                v-if="auth_store.user_id_getter"
                                class="ml-2 -mt-1 cursor-pointer"
                                :name="auth_store.user_id_getter"
                                :size="28"
                                v-on:click="navigateTo('/user/account')"
                            />
                        </span>
                        <span v-else>
                            <NuxtLink to="/user/signup">Sign up</NuxtLink>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'

const auth_store = useAuthStore()
</script>
